import { render, staticRenderFns } from "./form.vue?vue&type=template&id=b6832d5a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=b6832d5a&lang=less&scoped=true"
import style1 from "./form.vue?vue&type=style&index=1&id=b6832d5a&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6832d5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6832d5a')) {
      api.createRecord('b6832d5a', component.options)
    } else {
      api.reload('b6832d5a', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=b6832d5a&scoped=true", function () {
      api.rerender('b6832d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/need_goods_simple/form/form.vue"
export default component.exports